import IMG from '../../../helper-functions/companies/img-planids';

const imgPlanIds = new IMG();

export { imgPlanIds };
